import { z } from 'zod';

/**
 * Household split metodları (Monarch Money + Splitwise pattern):
 *  - equal: tüm üyelere eşit bölünür (1/N)
 *  - income_proportional: group_members.income_weight ağırlıklı
 *  - custom: groups.split_config jsonb { userId: percent } map
 */
export const householdSplitMethodSchema = z.enum([
  'equal',
  'income_proportional',
  'custom',
]);
export type HouseholdSplitMethod = z.infer<typeof householdSplitMethodSchema>;

export const createGroupSchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  sortOrder: z.number().int().optional(),
  isHousehold: z.boolean().optional().default(false),
  splitMethod: householdSplitMethodSchema.optional().default('equal'),
  splitConfig: z.record(z.string(), z.number().min(0).max(100)).optional(),
});
export type CreateGroupInput = z.infer<typeof createGroupSchema>;

export const updateGroupSchema = createGroupSchema.partial();
export type UpdateGroupInput = z.infer<typeof updateGroupSchema>;

export const groupRoleSchema = z.enum(['owner', 'admin', 'member']);
export type GroupRole = z.infer<typeof groupRoleSchema>;

export const inviteToGroupSchema = z.object({
  email: z.string().email().toLowerCase(),
  role: groupRoleSchema.default('member'),
  expiresInDays: z.number().int().min(1).max(30).default(7),
});
export type InviteToGroupInput = z.infer<typeof inviteToGroupSchema>;

export const acceptInvitationSchema = z.object({
  token: z.string().min(1),
});
export type AcceptInvitationInput = z.infer<typeof acceptInvitationSchema>;

export const updateMemberSchema = z.object({
  role: groupRoleSchema.optional(),
  isActive: z.boolean().optional(),
  /** Income-proportional split için kullanıcının ağırlığı (örn. 1.0, 0.7, vs.) */
  incomeWeight: z.coerce.number().min(0).max(1000).optional(),
});
export type UpdateMemberInput = z.infer<typeof updateMemberSchema>;
